import React, {useEffect, useRef, useState} from 'react';
import Select from "react-select";
import styled from "styled-components";
import shutter from './shutter.mp3';

const MainDiv=styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.7);

    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 1000;
`
const Canvas=styled.canvas`
    display: none;
`
const Video=styled.video`
    width: 90%;
    height: 80%;
    object-fit: contain;
    margin: 0 auto;
`
const SelectDevice=styled(Select)`
    margin: 10px auto;    
    width: 80%;
`
const Button=styled.button`
    position: fixed;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);

    width: 72px;
    height: 72px;
    border-radius: 50%;

    border: 4px solid white;
    background: rgba(255, 255, 255, 0.2);

    display: flex;
    justify-content: center;
    align-items: center;

    cursor: pointer;
    transition: all 0.2s ease;

    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.35);

    &:hover {
        transform: translateX(-50%) scale(1.08);
        background: rgba(255, 255, 255, 0.3);
    }

    &:active {
        transform: translateX(-50%) scale(0.92);
    }

    &::after {
        content: "";
        width: 52px;
        height: 52px;
        border-radius: 50%;
        background: white;
    }
`
const ButtonsDiv=styled.div`
    width: 50%
    `
const ZoomSlider = styled.input`
    flex: 1;
    appearance: none;
    height: 6px;
    margin-left: 0;
    border-radius: 9px;
    outline: none;
    margin-left: 0px;
    background: linear-gradient(
        90deg,
        #3b82f6 0%,
        #60a5fa 100%
    );

    &::-webkit-slider-thumb {
        appearance: none;
        width: 22px;
        height: 22px;
        border-radius: 50%;
        background: #fff;
        border: 3px solid #3b82f6;
        cursor: pointer;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
        transition: all 0.2s ease;
    }

    &::-webkit-slider-thumb:hover {
        transform: scale(1.15);
    }

    &::-moz-range-thumb {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        background: #fff;
        border: 3px solid #3b82f6;
        cursor: pointer;
    }
`;

const ZoomContainer = styled.div`
    position: relative;
    width: 100%;
    margin-top: -50px;
`;

const ZoomValue = styled.div`
    position: absolute;
    bottom: 28px;
    left: ${({ $percent }) => `calc(${$percent}% + ${11 - $percent * 0.22}px)`};
    transform: translateX(-50%);

    background: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 5px 9px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: bold;
    white-space: nowrap;
    pointer-events: none;
`;

const Camera = ({setPicture, setCameraOpen}) => {
    const [zoomRange, setZoomRange] = useState({
        min: 0.5,
        max: 5,
        step: 0.1
    });
    const [video, setVideo]=useState();
    const [zoom, setZoom]=useState(0.5)
    const canvas = document.querySelector('canvas');
    const [VideoDevices, setVideoDevices]=useState([]);
    const [Device, setDevice]=useState(null);
    const [GetPictureInterval, setGetPictureInterval]=useState();
    const shutterSound = useRef(null);

    const constraints = {
        video: {
             width:{ideal:1920},
             height:{ideal:1080}
        }
    };
    const zoomPercent =
        ((zoom - zoomRange.min) /
            (zoomRange.max - zoomRange.min)) * 100;

    function ChangeVideoDevice(value) {
        const updatedConstraints = {
            // ...constraints,
            video:{
                 ...constraints.video,
                deviceId: {
                    exact:  value.value
                }
            }
        };
        setDevice(value)
        startStream(updatedConstraints);
    };

    async function startStream  (constraints) {
        const stream = await navigator.mediaDevices.getUserMedia(constraints);
        video.srcObject = stream;
    };
    async function start(){
        const res=await startStream(constraints);
    }

    async function getDevices() {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const videoDevices = devices.filter(device => device.kind === 'videoinput');
        let temp=[];
        console.log(videoDevices)
        videoDevices.map(el=>{
            temp=[...temp, {value:el.deviceId, label:el.label}]
        })
        setVideoDevices(temp);
        setDevice(temp[0])
    }

    function doScreenShot(event){
        event.stopPropagation();

        if (shutterSound.current) {
            shutterSound.current.currentTime = 0;
            shutterSound.current.play().catch(err => {
                console.log("Ошибка воспроизведения звука:", err);
            });
        }

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas.getContext('2d').drawImage(video, 0, 0);
        // setPicture(canvas.toDataURL());
        canvas.toBlob((blob) => {
            setPicture(blob)

        }, 'image/png',1);
    };
    async function handleZoom(value) {
        setZoom(value);

        if (!video?.srcObject) return;

        const track = video.srcObject.getVideoTracks()[0];

        try {
            await track.applyConstraints({
                advanced: [
                    { zoom: Number(value) }
                ]
            });
        } catch (err) {
            console.log("Zoom wird von dieser Kamera nicht unterstützt", err);
        }
    }
    function closeCamera() {
        if (video?.srcObject) {
            video.srcObject.getTracks().forEach(track => track.stop());
        }
        video.srcObject = null;
        setCameraOpen(false);
    }
    // request camera permission
    navigator.mediaDevices.getUserMedia({video: true})


    useEffect(()=>{
        setVideo(document.getElementById("video"));
    },[])
    useEffect(()=>{
        if(video)
            start();
    },[video])
    useEffect(()=>{
        getDevices()
    },[]);

    useEffect(() => {
        shutterSound.current = new Audio(shutter);
        shutterSound.current.volume = 0.8;
    }, []);

    return (
        <MainDiv>
            <SelectDevice value={Device} options={VideoDevices} onChange={ChangeVideoDevice}/>
            <Video id="video" autoPlay onClick={closeCamera}/>
            <ButtonsDiv>
                <Button title="ScreenShot"  onClick={doScreenShot}/>
                <ZoomContainer>
                    <ZoomValue $percent={zoomPercent}>
                        {Number(zoom).toFixed(1)}x
                    </ZoomValue>

                    <ZoomSlider
                        type="range"
                        min={zoomRange.min}
                        max={zoomRange.max}
                        step={zoomRange.step}
                        value={zoom}
                        onChange={(e) => handleZoom(e.target.value)}
                        style={{ width: "100%" }}
                    />
                </ZoomContainer>
            </ButtonsDiv>
            <Canvas/>
        </MainDiv>
    );

};

export default Camera;